import React, { useContext } from "react";
import { useParams } from "react-router-dom";
import _ from "lodash";

import ToastWrapper from "@common/helpers/toastWrapper";
import { SelectionsContext } from "@common/contexts/selections";
import { SportTypesUrlIds } from "@racings/constants/enums/sportTypes";
import { RacingMarketTypes } from "@common/constants/enums/racingMarketTypes";

export const useSelections = () => {
	const { sportType } = useParams();
	const [selections, setSelections] = useContext(SelectionsContext);

	const { events } = selections;

	const toggleEvent = ({ event, activeMarketId, game, market, regionId, competitionId }) => {
		const eventToAdd = {
			...event,
			isRacingEvent: true,
			marketType: activeMarketId,
			racingType: SportTypesUrlIds[sportType],
		};

		const eventGame = {
			..._.omit(game, ["competition", "market", "region", "sport"]),
			competition: _.omit(game.competition, ["game"]),
			region: _.omit(game.region, ["competition"]),
			sport: _.omit(game.sport, ["region"]),
			competitionId: +competitionId,
			regionId: +regionId,
		};

		const singleEvent = Object.values(events).find(
			item => item.event.marketType === RacingMarketTypes.WINNER && item.game.id === eventGame.id
		);

		const singlesPerGame = Object.values(events).filter(
			item => item.event.marketType === RacingMarketTypes.WINNER
		);
		const selectedEvent = events[eventToAdd.id];
		const selectedEventsMarketId = Object.values(events)[0]?.event.marketType;

		if (selectedEventsMarketId && activeMarketId !== selectedEventsMarketId)
			return ToastWrapper("error", "Incompatible events");

		if (activeMarketId === RacingMarketTypes.WINNER) {
			if (
				selectedEvent &&
				selectedEvent.event.sp === eventToAdd.sp &&
				selectedEvent.event.id === eventToAdd.id
			) {
				setSelections({
					...selections,
					events: _.omit(events, eventToAdd.id),
				});
			} else {
				if (!singlesPerGame.length) {
					setSelections({
						...selections,
						events: {
							...events,
							[eventToAdd.id]: {
								event: eventToAdd,
								market,
								game: eventGame,
							},
						},
					});
				} else {
					setSelections({
						...selections,
						events: {
							..._.omit(events, singleEvent?.event.id),
							[eventToAdd.id]: {
								event: eventToAdd,
								market,
								game: eventGame,
							},
						},
					});
				}
			}
		} else {
			if (events[eventToAdd.id]) {
				setSelections({
					...selections,
					events: _.omit(events, eventToAdd.id),
				});
			} else {
				setSelections({
					...selections,
					events: {
						...events,
						[eventToAdd.id]: {
							event: eventToAdd,
							market,
							game: eventGame,
						},
					},
				});
			}
		}
	};

	return [events, toggleEvent];
};
